import React, { useContext, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Fab from '@material-ui/core/Fab';
import { Loader } from 'pixi.js'
import CloseIcon from '@material-ui/icons/Close';
import { Stage, Sprite, Container } from '@inlet/react-pixi'
import { Texture } from 'pixi.js'
import { Grid } from '@material-ui/core';

import HomeContext from '../../../context/home-context';
import { MoodMeter, LevelMeter, FoodMeter } from '../../shared/component'
import AlertBoxAnimationModal from './AlertBoxAnimationModal'
import DirtyIsland from './DirtyIsland'
import HowTo from './HowTo'
import MonsterMessages from '../../home/monster/MonsterMessages'
import MonsterContainer from '../../home/monster/MonsterContainer'
import MonsterEggContainer from '../../home/monster/MonsterEggContainer'
import InfoAlertBox from '../../home/monster/InfoAlertBox'
import ViewPort from '../../shared/PixiViewPort'

const domElement = document.querySelector('#root');
let initWidth = domElement.offsetWidth;
let initHeight = domElement.offsetHeight;

let standBySadTextures = [];
let jumpingTextures = [];
let messageTextures = [];
let messages = [];
let iconUrl = '';
let profileUrl = '';
let eggUrl = '';
let foodIconUrl = '';

const MonsterMenu = () => {
    const [notiOpen, setNotiOpen] = React.useState(false);
    const [messageBoxOpen, setMessageBoxOpen] = React.useState(false);
    const [infoBoxOpen, setInfoBoxOpen] = React.useState({ open: false, type: 'info' });
    const { homeContext, monsterMenuClose, dispatch } = useContext(HomeContext);
    const loader = Loader.shared; // PixiJS exposes a premade instance for you to use.

    if (initWidth < 2000) {
        initWidth = 1920;
        initHeight = 900;
    }
    let xInitial = (initWidth - 1000) / 2;
    let yInitial = (initHeight - 738) / 2;

    let backgroundTexture = Texture.from('./assets/images/components/island/particle/monsterMenuBG.png');
    let backgroundPath = loader.resources["./assets/images/components/island/spritesheets/dayOfTheIsland/afternoonBG.json"].textures[`island_bg-afternoon.png`];
    let foodText = 'Drumstick';
    let lvlText = "Stage 1";
    let lvlPercent = Math.floor(parseInt(homeContext.monsterMenu.feedCount) * 6.7);
    let feedCount = homeContext.monsterMenu.feedCount;
    if (homeContext.monsterMenu.feedCount >= 15 && homeContext.monsterMenu.feedCount < 30) {
        feedCount = homeContext.monsterMenu.feedCount - 15;
        lvlPercent = Math.floor((parseInt(homeContext.monsterMenu.feedCount) - 15) * 6.7);
        lvlText = "Stage 2";
    }
    else if (homeContext.monsterMenu.feedCount >= 30 && homeContext.monsterMenu.feedCount < 45) {
        feedCount = homeContext.monsterMenu.feedCount - 30;
        lvlPercent = Math.floor((parseInt(homeContext.monsterMenu.feedCount) - 30) * 6.7);
        lvlText = "Stage 3";
    }
    else if (homeContext.monsterMenu.feedCount >= 45) {
        feedCount = 15;
        lvlPercent = 100;
        lvlText = "Stage 4(Max)";
    }

    foodIconUrl = './assets/images/components/island/particle/drumstick.png';
    switch (homeContext.monsterMenu.cluster) {
        case 'HSS':
            iconUrl = homeContext.monsterMenu.moodMeter >= 50 ?
                "./assets/images/components/island/particle/monster/hss/hssIcon.png" : "./assets/images/components/island/particle/monster/hss/hss_sad.png";
            profileUrl = "./assets/images/components/island/particle/monster/hss/hss.png";
            eggUrl = "./assets/images/components/island/particle/eggs/SIT-egg-HSS.png";
            break;
        case 'DSB':
            iconUrl = homeContext.monsterMenu.moodMeter >= 50 ?
                "./assets/images/components/island/particle/monster/dsb/dsbIcon.png" : "./assets/images/components/island/particle/monster/dsb/dsb_sad.png";
            eggUrl = "./assets/images/components/island/particle/eggs/SIT-egg-DAB.png";
            profileUrl = "./assets/images/components/island/particle/monster/dsb/dsb.png";
            break;
        case 'ICT':
            iconUrl = homeContext.monsterMenu.moodMeter >= 50 ?
                "./assets/images/components/island/particle/monster/ict/ictIcon.png" : "./assets/images/components/island/particle/monster/ict/ict_sad.png";
            profileUrl = "./assets/images/components/island/particle/monster/ict/ict.png";
            eggUrl = "./assets/images/components/island/particle/eggs/SIT-egg-ICT.png";
            break;
        case 'CEFT':
            iconUrl = homeContext.monsterMenu.moodMeter >= 50 ?
                "./assets/images/components/island/particle/monster/ceft/ceftIcon.png" : "./assets/images/components/island/particle/monster/ceft/ceft_sad.png";
            profileUrl = "./assets/images/components/island/particle/monster/ceft/ceft.png";
            eggUrl = "./assets/images/components/island/particle/eggs/SIT-egg-Food.png";
            foodIconUrl = './assets/images/components/island/particle/berry.png';
            foodText = 'Berry';
            break;
        case 'ENG':
            eggUrl = "./assets/images/components/island/particle/eggs/SIT-egg-Engineer.png";
            iconUrl = homeContext.monsterMenu.moodMeter >= 50 ?
                "./assets/images/components/island/particle/monster/eng/engIcon.png" : "./assets/images/components/island/particle/monster/eng/eng_sad.png";
            profileUrl = "./assets/images/components/island/particle/monster/eng/eng.png";
            foodIconUrl = './assets/images/components/island/particle/berry.png';
            foodText = 'Berry';
            break;
    }

    useEffect(() => {
        loadMonsterTexture();
        loadMessages();
    }, []);

    useEffect(() => {

        if (homeContext.monsterMenu.open && homeContext.monsterMenu.isMissing) {
            setInfoBoxOpen({ open: true, type: 'warning' });
        }

    }, [homeContext.monsterMenu.open]);

    const loadMessages = () => {
        homeContext.monsterMenu.messages && homeContext.monsterMenu.messages.forEach((message) => {
            messages.push(`<strong>${message.title}</strong><br/>
        ${message.message}<br/><br/>
        <a class="adventurelearn_link_button" href="/Detail/LearningContent/${message.learningContentId}"}>Check this out</a>`);
        })
    }

    const loadMonsterTexture = () => {
        if (homeContext.monsterMenu.monsterLvl > 0) {

            for (let i = 0; i < 13; i++) {
                messageTextures.push(loader.resources["./assets/images/components/island/spritesheets/others/messages.json"].textures[`s${i}.png`])
            }
            switch (homeContext.monsterMenu.cluster) {
                case 'HSS':
                    for (let i = 24; i <= 96;) {
                        standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_sad.json"].textures[`HSS_sad_000${i}.png`])
                        i += 4;
                    }
                    for (let i = 3; i <= 60;) {

                        if (i >= 10) {
                            jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_jumping.json"].textures[`HSS_jumping up down_000${i}.png`])
                        }
                        else {
                            jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/hssDinosaur/hss_jumping.json"].textures[`HSS_jumping up down_0000${i}.png`])
                        }

                        i += 3;
                    }
                    break;
                case 'DSB':

                    for (let i = 3; i <= 60;) {
                        if (i > 9)
                            standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_sad.json"].textures[`DSB_sketch_anim standby sad_000${i}.png`])
                        else
                            standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_sad.json"].textures[`DSB_sketch_anim standby sad_0000${i}.png`])
                        i += 3;
                    }
                    for (let i = 1; i <= 39;) {
                        if (i > 9)
                            jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_jumping.json"].textures[`DSB_sketch_anim jump_000${i}.png`])
                        else
                            jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/dsbDinosaur/dsb_jumping.json"].textures[`DSB_sketch_anim jump_0000${i}.png`])
                        i += 2;
                    }
                    break;
                case 'ICT':

                    for (let i = 14; i <= 71;) {
                        standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_sad.json"].textures[`ICT_char_standby_sad_000${i}.png`])
                        i += 3;
                    }
                    for (let i = 2; i <= 40;) {

                        if (i >= 10) {
                            jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_jumping.json"].textures[`ICT_char_jump_000${i}.png`])
                        }
                        else {
                            jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ictDinosaur/ict_jumping.json"].textures[`ICT_char_jump_0000${i}.png`])
                        }

                        i += 2;
                    }
                    break;
                case 'CEFT':

                    for (let i = 9; i <= 66;) {
                        if (i >= 10) {
                            standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_sad.json"].textures[`CE&FS_green_standby_sad_000${i}.png`])
                        }
                        else {
                            standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_sad.json"].textures[`CE&FS_green_standby_sad_0000${i}.png`])
                        }
                        i += 3;
                    }
                    for (let i = 1; i <= 39;) {
                        if (i >= 10) {
                            jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_jumping.json"].textures[`CE&FS_green_jump_000${i}.png`])
                        }
                        else {
                            jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/ceftDinosaur/ceft_jumping.json"].textures[`CE&FS_green_jump_0000${i}.png`])
                        }
                        i += 2;
                    }
                    break;
                case 'ENG':

                    for (let i = 10; i <= 67;) {
                        standBySadTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_sad.json"].textures[`Engine_blue_reverse_standby_sad_000${i}.png`])
                        i += 3;
                    }
                    for (let i = 1; i <= 39;) {
                        if (i > 9)
                            jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_jumping.json"].textures[`Engine_blue_3_jump_000${i}.png`])
                        else
                            jumpingTextures.push(loader.resources["./assets/images/components/island/spritesheets/dinosaurs/engDinosaur/eng_jumping.json"].textures[`Engine_blue_3_jump_0000${i}.png`])
                        i += 2;
                    }
                    break;
            }
        }
    }

    const notiCloseClick = () => setNotiOpen(false);

    const notiOpenClick = () => setNotiOpen(true);

    const alertboxCloseClick = () => {
        setNotiOpen(false);
        homeContext.monsterMenu.moodMeter = 20;
        homeContext.monsterMenu.isMissing = false;
        dispatch({ type: 'SET_MONSTER_MENU', monsterMenu: homeContext.monsterMenu });
    }

    const messageBoxOpenClick = () => setMessageBoxOpen(true);

    const messageBoxCloseClick = () => setMessageBoxOpen(false);

    const infoAlertBoxOpenClick = (type) => {
        if (type === "info")
            setInfoBoxOpen({ open: true, type: 'info' });
        else
            setInfoBoxOpen({ open: true, type: 'warning' });
    }

    const infoAlertBoxCloseClick = () => setInfoBoxOpen({ open: false, type: 'info' });

    return (
        <>
            <Dialog fullScreen
                open={homeContext.monsterMenu.open}>
                {
                    homeContext.monsterMenu.monsterLvl > 0 ?

                        !homeContext.monsterMenu.isMissing ?
                            <>
                                <div>
                                    <div className="dino_levelMeterContainer">
                                        <LevelMeter lvlPercent={lvlPercent} lvlText={lvlText} feedCount={feedCount} iconUrl={iconUrl} />
                                    </div>
                                    <div className="dino_moodMeterContainer">
                                        <MoodMeter meterPercent={homeContext.monsterMenu.moodMeter}
                                            moodText={homeContext.monsterMenu.moodMeter >= 75 ? 'Happy' : homeContext.monsterMenu.moodMeter >= 50 ? 'Normal' : 'Sad'} />
                                    </div>
                                    <div className="dino_foodMeterContainer">
                                        <FoodMeter foodCount={homeContext.dailyChestClaim.foodCount} iconUrl={foodIconUrl}
                                            foodText={foodText} />
                                    </div>
                                </div>

                                <div className="weather default">
                                    <Grid container>
                                        <Stage width={initWidth} height={initHeight} options={{ backgroundColor: 0xffffff }}>
                                           
                                                {
                                                    homeContext &&
                                                    <HomeContext.Provider value={{ homeContext, dispatch }}>
                                                        <Sprite width={initWidth} height={initHeight} texture={backgroundPath} />
                                                        <Container x={xInitial} y={yInitial}>
                                                            <Sprite texture={backgroundTexture} />
                                                            <Container y={150}>
                                                                <MonsterContainer _openMessageBox={messageBoxOpenClick} _notiOpen={notiOpenClick} />
                                                            </Container>
                                                        </Container>
                                                    </HomeContext.Provider>
                                                }
                                           
                                            <AlertBoxAnimationModal _isOpen={notiOpen} _notiCloseClick={notiCloseClick} _textures={jumpingTextures} _text={'Congratulation! Dinosaur is promoted to next stage'} />
                                        </Stage>
                                    </Grid>
                                </div>
                            </>
                            :
                            <div className="weather default">
                                <Grid container>
                                    <Stage width={initWidth} height={initHeight} options={{ backgroundColor: 0xffffff }}>
                                        <ViewPort>
                                            <Sprite width={initWidth} height={initHeight} texture={backgroundPath} />
                                            <Container x={xInitial} y={yInitial}>
                                                <Sprite texture={backgroundTexture} />
                                                <Container y={150}>
                                                    {
                                                        homeContext &&
                                                        <HomeContext.Provider value={{ homeContext, notiOpenClick, dispatch }}>
                                                            <DirtyIsland />
                                                        </HomeContext.Provider>
                                                    }
                                                </Container>
                                            </Container>
                                        </ViewPort>
                                        <AlertBoxAnimationModal _isOpen={notiOpen} _notiCloseClick={alertboxCloseClick} _textures={standBySadTextures} _text={'Fantastic! Dinosaur is back'} />
                                    </Stage>
                                </Grid>
                            </div>
                        :
                        <div className="weather default">
                            <Grid container>
                                <Stage width={initWidth} height={initHeight} options={{ backgroundColor: 0xffffff }}>
                                    <ViewPort>
                                        <Sprite width={initWidth} height={initHeight} texture={backgroundPath} />
                                        <Container x={xInitial} y={yInitial}>
                                            <Sprite texture={backgroundTexture} />
                                            <Container y={150}>
                                                <MonsterEggContainer _eggUrl={eggUrl} _openMessageBox={() => infoAlertBoxOpenClick('info')} />
                                            </Container>
                                        </Container>
                                    </ViewPort>
                                </Stage>
                            </Grid>
                        </div>
                }
                <Fab
                    size="medium"
                    color="primary" className="dino_menuCloseContainer" onClick={monsterMenuClose}>
                    <CloseIcon />
                </Fab>
                {
                    homeContext.monsterMenu.monsterLvl > 0 ? <HowTo /> : <></>
                }
            </Dialog >
            <InfoAlertBox _open={infoBoxOpen.open} _handleClose={infoAlertBoxCloseClick} _alertBoxType={infoBoxOpen.type} />
            <MonsterMessages _open={messageBoxOpen} _handleClose={messageBoxCloseClick} _iconUrl={iconUrl} _messages={messages} />
        </>
    );
}

export { MonsterMenu as default }